module.exports = __webpack_public_path__ + "img/loading.99526853.png";